import selectBoxItemData from 'fulogics-ui-web/dist/layout/dx/SelectBox/helpers/selectBoxItemData';
import SelectBoxItemInspectorHelper from 'fulogics-ui-web/dist/layout/dx/SelectBox/helpers/SelectBoxItemInspectorHelper';
import SelectBoxItemTemplateProps from 'fulogics-ui-web/dist/layout/dx/SelectBox/templates/SelectBoxItemTemplateProps';
import React from 'react';
import ProductInfoModelSimpleText, {
    ProductInfoModelSimpleTextData,
    ProductInfoModelSimpleTextDataKeys,
    ProductInfoModelSimpleTextDisplayOptions,
} from '../../../../components/product-info-model-simple-text/ProductInfoModelSimpleText';

const ProductInfoModelSimpleTextItemTemplate = (props: SelectBoxItemTemplateProps) => {
    const data = selectBoxItemData(props);
    //
    return (
        <>
            <SelectBoxItemInspectorHelper selectBoxItemProps={props}>
                {(inspectorId, disableInspectorForm) => (
                    <ProductInfoModelSimpleText
                        disableInspectorForm={disableInspectorForm}
                        inspectorId={inspectorId}
                        data={data}
                        defaultProps={ProductInfoModelSimpleTextItemTemplateDefaultProps}
                    />
                )}
            </SelectBoxItemInspectorHelper>
        </>
    );
};
export const ProductInfoModelSimpleTextItemTemplateDefaultProps =
    {} as ProductInfoModelSimpleTextDisplayOptions;

export const ProductInfoModelSimpleTextItemTemplatePredProps = (
    current: SelectBoxItemTemplateProps
): SelectBoxItemTemplateProps => {
    return {
        ...current,
    };
};

export type ProductInfoModelSimpleTextItemTemplateData = ProductInfoModelSimpleTextData & {};
export const ProductInfoModelSimpleTextItemTemplateDataKeys = [
    ...ProductInfoModelSimpleTextDataKeys,
];

export default ProductInfoModelSimpleTextItemTemplate;
